import { useCallback, useMemo } from "react";
import { mutate } from "swr";

import { CreateOrganization } from "@organization/models/CreateOrganization";
import { CreateOrganizationResponse } from "@organization/models/CreateOrganizationResponse";

import { organizationEndpoints } from "@api/Endpoints";
import { postData } from "@hooks/usePostData";

export function useCreateOrganization() {
  const create = useCallback(async (organization: CreateOrganization) => {
    const url = organizationEndpoints.create();
    const result = await postData<
      CreateOrganization,
      CreateOrganizationResponse
    >(url, organization);
    await mutate(url);
    return result;
  }, []);
  return useMemo(() => ({ create }), [create]);
}
